var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-form-item',{staticClass:"file_item",attrs:{"label":_vm.data.fieldname}},[_c('a-upload',{attrs:{"multiple":true,"headers":{'X-Requested-With': null},"default-file-list":_vm.fileList},on:{"preview":_vm.onPreview}}),_c('gallery')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }